export default __webpack_public_path__ + "static/media/023-Surfboard.5ebe3572.svg";